import type { TenantBrandingFonts } from '@/lib/types/tenant';

export interface FontLookup {
  fonts: TenantBrandingFonts;
  locale: string;
}

// Kept apart from brand-fonts.ts so the chat's client code can name a font without shipping
// FONT_CONFIG: the root layout builds the @font-face CSS on the server.
export function getFontForLocale({ fonts, locale }: FontLookup): string | undefined {
  return fonts[locale] ?? fonts.default;
}

export function getPrimaryFontName(lookup: FontLookup): string | undefined {
  return getFontForLocale(lookup)?.split(',')[0]?.trim();
}
